import { useContext } from "react";
import {
  CustomMarkersContext,
  type CustomMarkersContextValue,
} from "../context/CustomMarkersContext";

export function useCustomMarkers(): CustomMarkersContextValue {
  const ctx = useContext(CustomMarkersContext);
  if (!ctx) {
    throw new Error(
      "useCustomMarkers must be used within CustomMarkersProvider",
    );
  }
  return ctx;
}
